"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyLoadSliderImage = exports.getElementIsVisiable = exports.getScrollPosition = exports.getSearchUrlFromKeywordAndSearchResultType = exports.webShare = exports.checkCanWebShare = exports.copyToClipboard = exports.loadImagesIfVisible = exports.lazyLoadManualImages = exports.lazyLoadImages = exports.lazyLoadImagesIn = exports.getElementById = exports.blurAll = exports.setTitle = exports.getIsGaLoaded = exports.getGlobalVariable = exports.setGlobalVariable = exports.getReturnUrl = exports.getSavedState = exports.saveState = exports.isSavedStateObjectExpired = exports.popState = exports.getShouldShowMenuPopup = exports.getIsMobileMd = exports.getIsMobile = exports.windowOpen = exports.getLatestSearchFilterUrl = exports.getElementClientHeight = exports.getElementScrollHeight = exports.getStickyTop = exports.getIsDfootShowing = exports.getElementBoundingRect = exports.getCurrentTime = exports.initGoogleRecaptcha = exports.changeUrlWithLanguage = exports.getHash = exports.removeAllHash = exports.setSearchSetIdHash = exports.isSaveNow = exports.getSearchTab = exports.getSearchId = exports.reload = exports.openTab = exports.setUrl = exports.getCurrentDomain = exports.getCurrentUrl = exports.checkIsChinese = exports.setKeywordBlur = exports.getSearchInputElement = exports.setElementFocus = exports.setElementBlur = exports.setNoScrollBody = exports.setAddressBar = exports.sliderInitedListener = exports.updateSlider = exports.updateLastCellPosition = exports.getScreenSize = exports.tabBlurListener = exports.unloadListener = exports.tabFocusListener = exports.domLoadedListener = exports.windowResizeListener = exports.hashChangeListener = exports.windowScrollListener = exports.resetSliders = exports.scrollSmoothWindowToKey = exports.scrollElementToKey = exports.scrollToEnquireTop = exports.scrollToFilterTop = exports.scrollToSearchTop = exports.scrollToMortgageCalculatorTop = exports.scrollToWindowTop = exports.getPageFromQueryParams = exports.popStateListener = void 0;
var redux_saga_1 = require("redux-saga");
var Api_1 = require("@/api/remote/Api");
var Pages_1 = require("@/rendering/common/Pages");
var StorageApi_1 = require("@/api/browser/StorageApi");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var GetSuggestionApiResponse_1 = require("@/pages/search/states/GetSuggestionApiResponse");
exports.popStateListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        window.onpopstate = listener;
        return function () {
            window.onpopstate = null;
        };
    });
};
exports.getPageFromQueryParams = function () {
    var params = new URLSearchParams(window.location.search);
    var pageParams = params.get("page") || "0";
    var page = isNaN(parseInt(pageParams, 10)) // string
        ? pageParams.toUpperCase()
        : Pages_1.Pages[parseInt(pageParams, 10)];
    return Pages_1.Pages[page];
};
exports.scrollToWindowTop = function (behavior) {
    if (behavior === void 0) { behavior = "instant"; }
    window.scrollTo({ top: 0, behavior: behavior });
};
exports.scrollToMortgageCalculatorTop = function () {
    var scrollable = document.getElementById("mortgagebody");
    scrollable.scrollTop = 0;
};
exports.scrollToSearchTop = function () {
    var scrollable = document.getElementsByTagName("html")[0];
    scrollable.scrollTop = 0;
};
exports.scrollToFilterTop = function () {
    var filterPanel = document.getElementById("sfilter-panel-body");
    if (!filterPanel)
        return;
    filterPanel.scrollTop = 0;
};
exports.scrollToEnquireTop = function () {
    var elm = document.getElementById("enquire-body");
    if (!elm)
        return;
    elm.scrollTop = 0;
};
exports.scrollElementToKey = function (element, key) {
    var parentElm = document.getElementById(element);
    var keyElm = document.getElementById(key);
    if (!parentElm || !keyElm)
        return;
    parentElm.scrollTop = keyElm.offsetTop;
};
exports.scrollSmoothWindowToKey = function (key) {
    var keyElm = document.getElementById(key);
    if (!keyElm)
        return;
    window.scrollTo({ behavior: "smooth", top: keyElm.offsetTop });
};
exports.resetSliders = function () {
    if (window.slider !== undefined)
        window.slider.reset();
};
exports.windowScrollListener = function (targetElement) {
    if (targetElement === void 0) { targetElement = null; }
    var newTargetElement = targetElement ? targetElement : window;
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            var scrollPos = targetElement
                ? targetElement.scrollTop
                : event.pageY
                    ? event.pageY
                    : window.pageYOffset;
            emit(scrollPos);
        };
        newTargetElement.addEventListener("scroll", listener);
        return function () {
            newTargetElement.removeEventListener("scroll", listener);
        };
    });
};
exports.hashChangeListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function () {
            emit({});
        };
        window.addEventListener("hashchange", listener);
        return function () {
            window.removeEventListener("hashchange", listener);
        };
    });
};
exports.windowResizeListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        window.addEventListener("resize", listener);
        return function () {
            window.removeEventListener("resize", listener);
        };
    });
};
exports.domLoadedListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        document.addEventListener("DOMContentLoaded", listener);
        return function () {
            document.removeEventListener("DOMContentLoaded", listener);
        };
    });
};
exports.tabFocusListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        window.addEventListener("focus", listener);
        return function () {
            window.removeEventListener("focus", listener);
        };
    });
};
exports.unloadListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        window.addEventListener("beforeunload", listener);
        return function () {
            window.removeEventListener("beforeunload", listener);
        };
    });
};
exports.tabBlurListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        window.addEventListener("blur", listener);
        return function () {
            window.removeEventListener("blur", listener);
        };
    });
};
exports.getScreenSize = function () {
    return window.innerWidth;
};
exports.updateLastCellPosition = function () {
    var resultItems = document.getElementsByClassName("c-result__item");
    if (!resultItems.length)
        return;
    var itemHeight = resultItems[0].getBoundingClientRect().height;
    var itemPos = Array.from(resultItems).map(function (it) { return it.getBoundingClientRect().top; });
    var lastItemPos = Math.max.apply(Math, itemPos);
    var lastPos = lastItemPos - itemHeight * 2 + window.scrollY;
    return lastPos;
};
exports.updateSlider = function () {
    setTimeout(function () {
        if (window.slider !== undefined)
            window.slider();
    }, 500);
};
exports.sliderInitedListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var listener = function (event) {
            emit(event);
        };
        document.addEventListener("sliderinited", listener);
        return function () {
            document.removeEventListener("sliderinited", listener);
        };
    });
};
exports.setAddressBar = function (newurl, replace) {
    if (replace === void 0) { replace = false; }
    var local = Api_1.isLocal();
    var title = document.title;
    var url = newurl || document.location.href;
    if (local)
        console.log("SETURL: " + url);
    if (replace) {
        window.history.replaceState(null, title, url);
    }
    else {
        window.history.pushState(null, title, url);
    }
};
exports.setNoScrollBody = function (state) {
    var bodyClasses = document.getElementsByTagName("body")[0].classList;
    if (state) {
        bodyClasses.add("u-noscroll");
        document.getElementById("app").classList.add("u-noscroll");
    }
    else {
        bodyClasses.remove("u-noscroll");
        document.getElementById("app").classList.remove("u-noscroll");
    }
};
exports.setElementBlur = function (element) {
    element.blur();
};
exports.setElementFocus = function (element) {
    element.focus();
};
exports.getSearchInputElement = function () {
    return document.getElementById("megasearch-input");
};
exports.setKeywordBlur = function () {
    document.getElementById("sfilter-keyword-text").blur();
};
exports.checkIsChinese = function (str) {
    if (!str)
        return false;
    return /[^a-zA-Z\d\s:]/g.test(str);
};
exports.getCurrentUrl = function () {
    return window.location.href;
};
exports.getCurrentDomain = function () {
    return window.location.origin;
};
exports.setUrl = function (url) {
    window.location.href = url;
};
exports.openTab = function (url) {
    window.open(url, "_blank").focus();
};
exports.reload = function () {
    location.reload();
};
exports.getSearchId = function () {
    var hash = window.location.hash;
    if (hash.length <= 1)
        return;
    var key = "#searchid=";
    if (hash.indexOf(key) !== 0)
        return;
    return hash.split(key)[1];
};
exports.getSearchTab = function () {
    var hash = window.location.hash;
    if (hash.length <= 1)
        return;
    var key = "#tab=";
    if (hash.indexOf(key) !== 0)
        return;
    return hash.split(key)[1];
};
exports.isSaveNow = function () {
    var hash = window.location.hash;
    if (hash.length <= 1)
        return;
    var key = "#savenow";
    if (hash.indexOf(key) !== 0)
        return;
    return true;
};
exports.setSearchSetIdHash = function (id) {
    window.history.replaceState(null, document.title, "#searchid=" + id);
};
exports.removeAllHash = function () {
    history.replaceState(null, document.title, window.location.pathname);
};
exports.getHash = function () {
    return location.hash.replace("#", "");
};
exports.changeUrlWithLanguage = function (languageDetails, newLanguageId) {
    var newLangCode = languageDetails.filter(function (it) { return it.id === newLanguageId; })[0]
        .code1;
    var currentUrl = window.location.href;
    var locales = ["zh-cn", "zh-hk", "en"];
    var isCurrentLocaleInLocales = false;
    var currentLocale = "";
    locales.forEach(function (it) {
        if (window.location.pathname.split("/")[1] === it) {
            isCurrentLocaleInLocales = true;
            currentLocale = it;
        }
    });
    if (isCurrentLocaleInLocales) {
        return currentUrl.replace(currentLocale, newLangCode);
    }
    return window.location.origin + "/" + newLangCode + window.location.pathname + window.location.search;
};
exports.initGoogleRecaptcha = function () {
    var recapElm = document.createElement("script");
    recapElm.type = "text/javascript";
    recapElm.src = "//www.google.com/recaptcha/api.js";
    document.getElementsByTagName("body")[0].appendChild(recapElm);
};
exports.getCurrentTime = function () { return new Date().getTime(); };
exports.getElementBoundingRect = function (elementId) {
    var element = document.getElementById(elementId);
    if (!element)
        return false;
    return element.getBoundingClientRect();
};
exports.getIsDfootShowing = function (scrolled) {
    var dfoot = document.getElementById("dfoot");
    return dfoot.offsetTop < scrolled + window.innerHeight;
};
exports.getStickyTop = function (elementId) {
    var elm = document.getElementById(elementId);
    if (!elm)
        return null;
    return elm.offsetTop;
};
exports.getElementScrollHeight = function (elementId) {
    var elm = document.getElementById(elementId);
    if (!elm)
        return null;
    return elm.scrollHeight;
};
exports.getElementClientHeight = function (elementId) {
    var elm = document.getElementById(elementId);
    if (!elm)
        return null;
    return elm.clientHeight;
};
exports.getLatestSearchFilterUrl = function () {
    if (document.referrer.indexOf("property-search") > 0) {
        return document.referrer;
    }
    return null;
};
exports.windowOpen = function (url) {
    window.open(url);
};
exports.getIsMobile = function () {
    return exports.getScreenSize() <= 1280;
};
exports.getIsMobileMd = function () {
    return exports.getScreenSize() <= 768;
};
exports.getShouldShowMenuPopup = function () {
    return exports.getScreenSize() <= 1440;
};
exports.popState = function () {
    var hash = window.location.hash || null;
    window.history.back();
    setTimeout(function () {
        window.history.replaceState(null, document.title, hash);
    }, 100);
};
exports.isSavedStateObjectExpired = function (create) {
    var now = exports.getCurrentTime();
    var tenSec = 10 * 1000;
    return now - create > tenSec;
};
exports.saveState = function (state) {
    var currentTime = exports.getCurrentTime();
    StorageApi_1.setLocalStorage("state", JSON.stringify({
        data: state,
        create: currentTime,
    }));
};
exports.getSavedState = function () {
    var savedStateStr = StorageApi_1.popLocalStorage("state");
    if (!savedStateStr)
        return;
    var savedStateObject = JSON.parse(savedStateStr);
    if (!savedStateObject.create)
        return;
    var hasExpired = exports.isSavedStateObjectExpired(savedStateObject.create);
    if (hasExpired)
        return;
    return savedStateObject.data;
};
exports.getReturnUrl = function () {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("ReturnUrl") || "/";
};
exports.setGlobalVariable = function (key, value) {
    window[key] = value;
};
exports.getGlobalVariable = function (key) {
    return window[key];
};
exports.getIsGaLoaded = function () {
    if (window.ga && window.ga.create)
        return true;
    return false;
};
exports.setTitle = function (title) {
    if (!document)
        return;
    document.title = title;
};
exports.blurAll = function () {
    document.querySelectorAll("input").forEach(function (it) { return it.blur(); });
};
var loadImage = function (element, forceReload) {
    if (forceReload === void 0) { forceReload = false; }
    var originalSrc = element.getAttribute("src");
    if (!originalSrc || forceReload) {
        var dataSrc = element.getAttribute("data-src");
        if (dataSrc) {
            element.setAttribute("src", dataSrc);
        }
    }
};
exports.getElementById = function (id) {
    return document.getElementById(id);
};
exports.lazyLoadImagesIn = function (parentElement, forceReload) {
    if (forceReload === void 0) { forceReload = false; }
    if (!parentElement)
        return;
    var lazyLoadElements = parentElement.querySelectorAll("img[data-src], iframe[data-src]");
    if (!lazyLoadElements || !lazyLoadElements.length)
        return;
    lazyLoadElements.forEach(function (it) {
        loadImage(it, forceReload);
    });
};
exports.lazyLoadImages = function (forceReload) {
    if (forceReload === void 0) { forceReload = false; }
    document.querySelectorAll("img[data-src], iframe[data-src]").forEach(function (it) {
        loadImage(it, forceReload);
    });
};
exports.lazyLoadManualImages = function () {
    document
        .querySelectorAll("img[data-src][data-lazy=manual], iframe[data-src][data-lazy=manual]")
        .forEach(function (it) {
        loadImage(it);
    });
};
exports.loadImagesIfVisible = function () {
    document.querySelectorAll("img[data-src], iframe[data-src]").forEach(function (it) {
        if (it.getBoundingClientRect().top < document.documentElement.clientHeight) {
            if (it.getAttribute("data-lazy") === "manual")
                return;
            loadImage(it);
        }
    });
};
exports.copyToClipboard = function (url) {
    navigator.clipboard.writeText(url);
};
exports.checkCanWebShare = function () { return window.navigator.canShare; };
exports.webShare = function (shareInfo) {
    return Promise.all(shareInfo.files
        .map(function (it) {
        return fetch(it)
            .then(function (response) { return ({
            response: response,
            url: it,
        }); })
            .then(function (it) {
            return it.response.blob().then(function (blob) { return ({
                blob: blob,
                url: it.url,
            }); });
        })
            .then(function (it) {
            var urlPcs = it.url.split("/");
            var fileName = urlPcs[urlPcs.length - 1];
            if (it.blob.type.indexOf("image/") !== 0)
                return null;
            return new File([it.blob], fileName, {
                type: it.blob.type,
                lastModified: new Date().getTime(),
            });
        });
    })
        .filter(function (it) { return it; }))
        .then(function (files) {
        return {
            files: files,
            text: shareInfo.text,
            title: shareInfo.title,
            url: shareInfo.url,
        };
    })
        .then(function (sharable) {
        navigator.share(sharable);
        return true;
    });
};
exports.getSearchUrlFromKeywordAndSearchResultType = function (keyword, searchFilterType, searchResultType, searchResultId, lang) {
    var typeStr = searchFilterType === SfilterTypeGroup_1.SfilterType.BUY ? "buy" : "rent";
    if (searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.Building) {
        // Include building ID in URL to avoid name lookup ambiguity
        if (searchResultId && searchResultId > 0) {
            return "/" + lang + "/property-search/map/" + typeStr + "/building/" + keyword + "/" + searchResultId;
        }
        return "/" + lang + "/property-search/map/" + typeStr + "/building/" + keyword;
    }
    if (searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.Block) {
        // Include building block ID in URL if available
        if (searchResultId && searchResultId > 0) {
            return "/" + lang + "/property-search/map/" + typeStr + "/building/block/" + keyword + "/" + searchResultId;
        }
        return "/" + lang + "/property-search/map/" + typeStr + "/building/block/" + keyword;
    }
    // southside
    if (searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.SpecialDistrict &&
        searchResultId === 1)
        return "/" + lang + "/property-search/" + typeStr + "/localityarea-a1-d7-d99-d22-d26-d27-d111-d30-d32";
    // mid levels
    if (searchResultType === GetSuggestionApiResponse_1.GetSuggestionResultType.SpecialDistrict &&
        searchResultId === 2)
        return "/" + lang + "/property-search/" + typeStr + "/localityarea-a1-d14-d15-d17";
    return "/" + lang + "/property-search/map/" + typeStr + "/" + keyword + "-keyword";
};
exports.getScrollPosition = function () {
    return 0 - document.body.getBoundingClientRect().top;
};
exports.getElementIsVisiable = function (elementSelector) {
    var elms = document.querySelectorAll(elementSelector);
    if (elms.length < 1)
        return false;
    var elm = elms[0];
    if (!elm)
        return false;
    var elmPosition = elm.getBoundingClientRect().top;
    var winHeight = window.innerHeight;
    return elmPosition < winHeight * 0.8; // at least at 80% of screen height
};
exports.lazyLoadSliderImage = function () {
    if (!window || window === undefined)
        return;
    window.dispatchEvent(new CustomEvent("scroll"));
};
